const MONDELEZ_LEVEL_COLORS = {
  green: '#32a852',
  lighYellow: '#f2f291',
  yellow: '#ffe017',
  red: '#ff0000',
}

export { MONDELEZ_LEVEL_COLORS }
